import type { ConditionSourceViews, ViewVersions } from '@cognite/apm-client';

export function getViewVersion(
  sourceView: ConditionSourceViews,
  viewVersions: Pick<ViewVersions, 'TEMPLATE_ITEM' | 'CHECKLIST_ITEM'>
): string {
  switch (sourceView) {
    case 'TemplateItem':
      return viewVersions.TEMPLATE_ITEM;
    case 'ChecklistItem':
      return viewVersions.CHECKLIST_ITEM;
    default: {
      const _exhaustiveCheck: never = sourceView;
      throw new Error(`Unhandled sourceView: ${_exhaustiveCheck}`);
    }
  }
}
